import { useQuery } from '@tanstack/react-query';
import { actionRequiredService, GET_ALL_ACTION_REQUIRED } from '@/api';

export const useAllActionRequired = () => {
	return useQuery({
		queryKey: [GET_ALL_ACTION_REQUIRED],
		queryFn: () => actionRequiredService.getAllActionRequired(),
	});
};
